// ./src/components/layouts/DashboardLayout/constants.ts

// Single source of truth for DashboardLayout dimensions.
// Import these wherever a component needs to know about layout geometry
// (sticky bars, scroll offsets, spacing from the bottom tab bar, etc.).

// ============================================
// Bottom Tab Bar
// ============================================

/**
 * Height of the mobile bottom tab bar in pixels.
 * Matches the `height` prop on <BottomTabBar> and the
 * `paddingBottom` applied to AppShell.Main in DashboardLayout.
 */
export const BOTTOM_TAB_BAR_HEIGHT = 90;

// ============================================
// Sticky Element Gaps
// ============================================

/**
 * Gap between a sticky bar and the bottom tab bar (mobile)
 * or the viewport bottom edge (desktop).
 */
export const STICKY_BOTTOM_GAP = 12;

// ============================================
// Derived values (convenience)
// ============================================

/**
 * Total bottom offset for a sticky element on mobile:
 * sits visibly above the bottom tab bar with a small gap.
 */
export const STICKY_BOTTOM_MOBILE = BOTTOM_TAB_BAR_HEIGHT + STICKY_BOTTOM_GAP;

/**
 * Total bottom offset for a sticky element on desktop:
 * just the gap from the viewport edge.
 */
export const STICKY_BOTTOM_DESKTOP = STICKY_BOTTOM_GAP;

export type FooterMessageType = "info" | "success" | "warning" | "error";

export const SIDEBAR_WIDTH = 260;

/**
 * Height of the desktop top bar. The page header and the sidebar's logo block
 * share this value so their bottom borders line up across the two columns.
 */
export const HEADER_HEIGHT = 73;

export const FOOTER_ICON_MAP: Record<FooterMessageType, string> = {
  success: "Check",
  warning: "AlertTriangle",
  error: "X",
  info: "InfoCircle",
};

export const FOOTER_COLOR_MAP: Record<FooterMessageType, string> = {
  success: "success",
  warning: "warning",
  error: "error",
  info: "brand",
};

/** Default icon color when none specified in sitemap */
export const DEFAULT_ICON_COLOR = "#868E96";

/** Helper to create a light background from a hex color (~8% opacity) */
export const getIconBgColor = (hexColor: string): string => {
  return `${hexColor}14`;
};

